import * as React from 'react';
import {
    Bar,
    BarChart,
    YAxis,
} from 'recharts';

const Colors = [
    '#005AFF', '#FF4B00', '#FFF100', '#990099', '#4DC4FF', '#03AF7A', '#F6AA00', '#003699', '#992D00', '#999100',
    '#330033', '#2E7699', '#014A34', '#8F6300', '#669CFF', '#FF9366', '#FFF766', '#993D99', '#B2E6FF', '#4AAF90',
    '#F6C862', '#0048CC', '#CC3C00', '#CCC100', '#660066', '#3E9DCC', '#027D57', '#C28600', '#99BDFF', '#FFB799',
    '#FFF999', '#995C99', '#E5F7FF', '#6DAF9B', '#F6D894' ,'#41B3C8', '#96518A', '#874B3C', '#1E5323', '#9474fE',
    '#E47481', '#58BEB5', '#A8CA5A', '#244B4A', '#64A717', '#5DECE4', '#4BFD0C', '#C035F0', '#518D3B', '#093534',
    '#919AF0', '#306258', '#0B8F33', '#391347', '#F34DE3', '#F569BB', '#94905D', '#3BFEE3', '#1951FE', '#B6A551',
    '#CE7F1C', '#4B514A', '#B2E578', '#5E9359', '#E0E9C8', '#16623C', '#397261', '#EBEC42', '#B4B99E', '#B28125',
    '#FA60CD', '#908BE1', '#2B8034', '#460BE8', '#9EA5AE', '#DEF926', '#15D03C', '#F62570', '#D56A79', '#609E19',
    '#B72C70', '#7463BB', '#8231B5', '#8142C1', '#FBEEC4', '#3EFD4B', '#25E94F', '#26B1EC', '#EC48A4', '#FD166A',
    '#01442D', '#16BBBF', '#1DA317', '#E8C97D', '#712F6B', '#B48E8C', '#EF4EDA', '#869167', '#32962F', '#521FBC',
    '#0C7771', '#676797', '#6FCC35', '#676CD1', '#D21032', '#E10E93', '#40BE4D', '#A6DE8E', '#0022F9', '#F40F39',
];

const FiveLevelColors = [
    '#ED2100',
    '#FFB800',
    '#FAFF00',
    '#63D20A',
    '#006E18',
];

const WeatherColors = [
    '#ED2100',
    '#FFB800',
    '#63D20A',
    '#006E18',
];

type Props = {
    data: [Record<string, { count: number, name: string }>]
    loading: boolean
    max: number
    questionType: EverydayNote.QuestionTypes | undefined
    style?: React.CSSProperties
}

const SimpleGraph: React.FC<Props> = ({
    data,
    loading,
    max,
    questionType,
    style = {}
}) => {
    if(loading) return null;

    const keys = Object.keys(data[0]);

    const dataKeys = questionType === 4 || questionType === 9 ? keys.reverse() : keys;

    const fill = questionType === 4 ? FiveLevelColors : questionType === 9 ? WeatherColors : Colors;

    const colorsNum = fill.length;

    const newData = data.map(d => Object.fromEntries(dataKeys.map(key => [key, d[key].count])));

    return (
        <BarChart data={newData} width={80} height={50} style={style}>
            <YAxis domain={[0, max]} hide/>
            {dataKeys.map((dataKey, i) => (
                <Bar key={dataKey} dataKey={dataKey} fill={fill[i % colorsNum]} />
            ))}
        </BarChart>
    );
}

export default SimpleGraph;
